import { FileText, Download, BookOpen } from "lucide-react";

export function PdfSupport() {
  return (
    <section className="py-24">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto bg-card rounded-2xl border border-border p-8 md:p-12 flex flex-col md:flex-row items-center gap-8">
          <div className="w-20 h-20 rounded-2xl bg-accent-gold/10 flex items-center justify-center shrink-0">
            <FileText className="h-10 w-10 text-accent-gold" />
          </div>
          <div className="text-center md:text-left">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground mb-3">
              ¿Prefieres leer? También tenemos PDFs
            </h2>
            <p className="text-muted-foreground mb-4 leading-relaxed">
              Además de audio, ofrecemos libros completos en formato PDF. Descarga, marca páginas y estudia a tu ritmo.
            </p>
            <div className="flex items-center gap-4 text-sm text-muted-foreground justify-center md:justify-start">
              <span className="flex items-center gap-1"><Download className="h-4 w-4" />Descargable</span>
              <span className="flex items-center gap-1"><BookOpen className="h-4 w-4" />Texto completo</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
